 const ADMIN_BASE_URL = "https://downloadforever.ir/saeed/RealEstate/public/api/admin";
//  const ADMIN_BASE_URL = "http://192.168.1.121:6565/api/admin";
 export default ADMIN_BASE_URL;
